import CloseIcon from "@mui/icons-material/Close";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { LabelCompo } from "../../components/Comman/Label";

import { ButtonCompo } from "../../components/Comman/Button";
import { blackColor, checkboxColor } from "../../config/ColorObj";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ClaimDetailsPopUp = ({
    handleCloses,
    open,
    claimDetailsData,
    addClaimType,
}) => {
    console.log(claimDetailsData)

    const beatAllowanceTypes =
        JSON.parse(localStorage.getItem("isShowBeatAllowanceTypesNames")) || {};

    const handleClose = () => {
        handleCloses();
    };
    return (
        <>
            <Paper sx={{ p: 3, pt: 2, borderRadius: 2 }} elevation={0}>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth="md"
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                    >
                        Claim Details
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <DynamicDetails
                            DataToSet={[
                                {
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    label: "Date",
                                    value: claimDetailsData.date !== null ? claimDetailsData.date : "",
                                },
                                {
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    label: "Sales Team",
                                    value: claimDetailsData.salesTeamName !== null && claimDetailsData.stockStakeHolderTypePrefix !== null ?
                                        claimDetailsData.salesTeamName + " (" + claimDetailsData.stockStakeHolderTypePrefix + ")" : "",
                                },
                                {
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    label: "Claim Status",
                                    value:
                                        claimDetailsData.claimStatus !== null
                                            ? claimDetailsData.claimStatus == 0
                                                ? "Pending for approval"
                                                : claimDetailsData.claimStatus == 1
                                                    ? "Cancelled"
                                                    : claimDetailsData.claimStatus == 2
                                                        ? "Approved"
                                                        : "Rejected"
                                            : "",
                                },
                                ...(addClaimType == 1
                                    ? [
                                        {
                                            xs: 12,
                                            sm: 6,
                                            md: 6,
                                            lg: 6,
                                            label: "Remark",
                                            value:
                                                claimDetailsData.beatWorkInfo.length !== 0 &&
                                                    claimDetailsData.beatWorkInfo[0].remark !== null
                                                    ? claimDetailsData.beatWorkInfo[0].remark
                                                    : "-",
                                        },
                                    ]
                                    : []),
                            ]}
                        />



                        <DialogContent>
                            {claimDetailsData.beatWorkInfo.length != 0 && (
                                <>
                                    <TableContainer>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" sx={{ width: "3%" }}>
                                                        Sr. No
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ width: "20%" }}>
                                                        Beat Name
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ width: "20%" }}>
                                                        Beat Type
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ width: "20%" }}>
                                                        Travel Allowance
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ width: "20%" }}>
                                                        Daily Allowance
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ width: "15%" }}>
                                                        Total
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {claimDetailsData.beatWorkInfo.map((claimDataObj, indexRow) => {
                                                    let beatType1 = beatAllowanceTypes?.beatType1 || "-";
                                                    let beatType2 = beatAllowanceTypes?.beatType2 || "-";

                                                    return (

                                                        <TableRow>
                                                            <TableCell width="10%" align="center">
                                                                {indexRow + 1}
                                                            </TableCell>
                                                            <TableCell align="left">{claimDataObj.beatName}</TableCell>
                                                            <TableCell align="left">
                                                                {claimDataObj.beatType !== null ? (claimDataObj.beatType == 0 ?
                                                                    beatType1 : beatType2) : ""}
                                                            </TableCell>
                                                            {claimDetailsData.isEdited == 1 || addClaimType == 1 ?
                                                                (
                                                                    <>
                                                                        <TableCell align="right">{claimDataObj.travelAllowance !== null
                                                                            && claimDataObj.travelAllowance.editedClaimAmt !== null
                                                                            ? claimDataObj.travelAllowance.editedClaimAmt.toFixed(2) : 0}</TableCell>
                                                                        <TableCell align="right">{claimDataObj.dailyAllowance !== null
                                                                            && claimDataObj.dailyAllowance.editedClaimAmt !== null
                                                                            ? claimDataObj.dailyAllowance.editedClaimAmt.toFixed(2) : 0}</TableCell>
                                                                        <TableCell align="right">{claimDataObj.totalEditedClaimAmt.toFixed(2)}</TableCell>

                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <TableCell align="right">{claimDataObj.travelAllowance !== null
                                                                            && claimDataObj.travelAllowance.amt !== null
                                                                            ? claimDataObj.travelAllowance.amt.toFixed(2) : 0}</TableCell>
                                                                        <TableCell align="right">{claimDataObj.dailyAllowance !== null
                                                                            && claimDataObj.dailyAllowance.amt !== null
                                                                            ? claimDataObj.dailyAllowance.amt.toFixed(2) : 0}</TableCell>
                                                                        <TableCell align="right">{claimDataObj.total.toFixed(2)}</TableCell>
                                                                    </>
                                                                )
                                                            }


                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Grid
                                        item
                                        sm={12}
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        container
                                        justifyContent="right"
                                        sx={{ marginTop: 2, padding: 2 }}
                                    >
                                        <Typography variant="h6">{"Final Total :" + " " + claimDetailsData.finalTotal.toFixed(2)}</Typography>

                                    </Grid>

                                </>
                            )}

                            <br />
                        </DialogContent>
                    </DialogContent>

                </BootstrapDialog>
            </Paper>
        </>
    );
};
const mapStateToProps = (state) => ({
    beatList: state.beat,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ClaimDetailsPopUp);
